import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=60a20669&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a20669')) {
      api.createRecord('60a20669', component.options)
    } else {
      api.reload('60a20669', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=60a20669&", function () {
      api.rerender('60a20669', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/Item.vue"
export default component.exports